import { TRPCClientError } from "@trpc/client";
import { WorkSiteErrorType } from "@remi/error";

export const isAddressUnitRequiredError = (error: unknown): boolean =>
  error instanceof TRPCClientError && error.data?.errorType === WorkSiteErrorType.WORKSITE_ADDRESS_UNIT_REQUIRED;
